export default {
  white: '#fff',
  green: '#2CA360',
  red: '#F9324C',
  reddish: 'hsla(352, 84%, 50%, 1)',
  blackish: '#3C4142',
  greyish: '#D8D8D8',
  lightGrey: '#E5E5E5',
  darkGrey: '#949FA1',
  lightLightGrey: '#F1F1F1',
  midGrey: '#A9A9A9',
}
